import { Stack } from '@mui/material'
import { providerSectionCopy } from '@/features/chat/phase1/providerSectionCopy'
import StepsSection from './StepsSection'
import TaskSection from './TaskSection'

export default function WorkSectionsBody({
  plan,
  confirmed,
  steps,
  trimmed,
  streaming,
  citations = [],
}) {
  const providerCopy = providerSectionCopy(confirmed)
  return (
    <Stack sx={{ gap: 0, mt: 0.75 }}>
      {plan.length ? (
        <TaskSection
          title="Agent's plan"
          caption="The agent's own account of its work."
          tasks={plan}
          streaming={streaming}
          checklist
        />
      ) : null}
      {confirmed.length ? (
        <TaskSection
          {...providerCopy}
          tasks={confirmed}
          streaming={streaming}
        />
      ) : null}
      {steps.length ? (
        <StepsSection
          steps={steps}
          trimmed={trimmed}
          streaming={streaming}
          narrate={!plan.length && !confirmed.length}
          citations={citations}
        />
      ) : null}
    </Stack>
  )
}
